import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, Renderer2 } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import config from 'config/default.json';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import { TableComponent } from '../../table/table.component';
import { FormControl } from '@angular/forms';
@Component({
  selector: 'app-student-detail',
  templateUrl: './student-detail.component.html',
  styleUrls: ['./student-detail.component.scss', '../../../components/table/table.component.scss']
})
export class StudentDetailComponent extends TableComponent{
  constructor(
      private elRef:ElementRef,
      private cdRef: ChangeDetectorRef,
      private apiService: ApiServiceModule,
      public sanitizer: DomSanitizer,
      private renderer: Renderer2,
      private helper: HelperModule,
      public dialog: MatDialog
      ) {
        super(sanitizer);
      }
  @Output() inProgress = new EventEmitter<any>();
  @Input() promotionAllData: any;
  @Input() rowInfos: { [x:string]: any } = new Map();
  @Input() userInfos: { [x:string]: any } = new Map();
  @Input() platformInfos: { [x:string]: any } = new Map();
  
  productControl = new FormControl();
  promotionControl = new FormControl();
  activeControl = new FormControl();
  productData: any[] = [];
  promotionData: any[] = [];
  promotionType = ''
  promoDuration = 0;
  ngOnInit(){
    this.promotionData = this.promotionAllData.promotion;
    console.log(this.promotionData)
    this.productData = this.promotionAllData.product;
    this.loadSubscriptions();
  }
  loadPromotions(){
    let idProduct = this.productControl.value;
    this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/promotion/load_promotion', {id_product: idProduct, id_user: this.userInfos['id_user'], platform_infos: this.platformInfos}, this.userInfos['access_token']).subscribe((response: any)=>{
      this.promotionData = response;
      this.updateDetail();
    })
  }
  loadSubscriptions(){
    let inputData = {
      id_student: this.rowInfos['id_student'],
      user_infos: this.userInfos,
      platform_infos: this.platformInfos
    }; 
    this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/student/load_subscription', inputData, this.userInfos['access_token']).subscribe((response:any)=>{
      this.dataSource = response;
      this.showedRows = this.dataSource;
    })
  }
  createPromotion(){
    let inputData = {
      id_student: this.rowInfos['id_student'],
      id_promotion: this.promotionControl.value ?? 0,
      promo_type:  this.promotionType,
      duration: this.promoDuration,
      user_infos: this.userInfos,
      platform_infos: this.platformInfos
    }; 
    this.apiService.queryData(config.master.ndapi.url + '/enovsky/mobile/subscription/create_subscription', inputData, this.userInfos['access_token']).subscribe((response:any)=>{
      this.helper.showToast(response.message); 
    })
  }
  updateDetail(){
    let idProduct = this.productControl.value ?? 0;
    let idPromotion = this.promotionControl.value ?? 0;
    
    let product = this.promotionData.find((element: any) => element.id == idProduct) || {price: 0};
    let promotion = this.promotionData.find((element: any) => element.id == idPromotion) || {id: 0};
    this.promotionType = promotion.promo_type;
    this.promoDuration = promotion.duration;
  }
  applyFilterLocal(element:any, column:string){
    let tableBody = this.elRef.nativeElement.querySelector('tbody');
    this.removeDetailsRows(tableBody);
    this.applyFilter(element.value, column);
    this.cdRef.detectChanges();
  }
  applySortLocal(element:any, column:string, type:string){
    let tableBody = this.elRef.nativeElement.querySelector('tbody');
    this.removeDetailsRows(tableBody);
    this.applySort(element, column, type);
    this.cdRef.detectChanges();
  }

}
